import { clsx } from 'clsx';
import Image from '@/src/shared/components/Image';
import React from 'react';
import { useDispatch } from 'react-redux';
import PopupManager from '@/src/core/components/PopupManager';
import styles from '@/src/containers/SimplifyLandingPageForms/components/JoinOverRow/JoinOverRow.module.scss';
import { openNewPopup } from '@/redux/popup-manager/actions';
import c from './index.module.scss';
import VideoPlayer from './video-player';
import { useNumberOfUsers } from '@/src/data/general/useNumberOfUsers';
import { useBookDemoEvent } from '@/src/core/hooks/useBookDemoEvent';
import realtorLogos from '../SimplifyLandingPageForms/components/JoinOverRow/realtor-logos';
import BrokerageLogoGroup from '../SimplifyLandingPageForms/components/JoinOverRow/BrokerageLogoGroup';
import CompanyLogo from '../SimplifyLandingPageForms/components/CompanyLogo';
import Footer from '../Landings/Footer';
import TestimonialGrid from './testimonial-grid';

export default function RestOfPage(props) {
  const dispatch = useDispatch();
  const { data: agents = 0 } = useNumberOfUsers();
  const { sendBookDemoEvent } = useBookDemoEvent();

  const firstLogoGroup = realtorLogos.slice(0, 6);
  const secondLogoGroup = realtorLogos.slice(6, 12);

  return (
    <>
      <div className={c.groupIconsWrapper}>
        <div className={c.groupIcons}>
          <Image src="/images/testimonials/group-icons.webp" fill alt="group" />
        </div>
      </div>

      <div className={clsx(styles.container, c.mobileOnly)}>
        <BrokerageLogoGroup logos={firstLogoGroup} />
        <BrokerageLogoGroup logos={secondLogoGroup} />
      </div>

      <div className={clsx(c.mainTitle, c.titleSpacer)}>
        Over {(Math.floor(agents / 1000) * 1000).toLocaleString()} REALTORS
        &reg;
      </div>
      <div className={clsx(c.centered, c.subtitle)}>
        Managing their social media marketing and sharing branded content with
        <a href="https://www.roomvu.com">&nbsp;Roomvu</a>
      </div>

      <div className={c.socialIconsWrapper}>
        <b>4,000,000</b> Monthly Impressions
      </div>

      <div className={c.bubblesContainer}>
        <div className={c.bubble}>
          <div className={c.icon}>
            <Image
              src="/images/landing/icons/social/colored/facebook.png"
              fill
              alt="facebook"
            />
          </div>
        </div>
        <div className={c.bubble}>
          <div className={c.icon}>
            <Image
              src="/images/landing/icons/social/colored/linkedin.png"
              fill
              alt="linkedin"
            />
          </div>
        </div>
        <div className={c.bubble}>
          <div className={c.icon}>
            <Image
              src="/images/landing/icons/social/colored/twitter.png"
              fill
              alt="twitter"
            />
          </div>
        </div>
        <div className={c.bubble}>
          <div className={c.icon}>
            <Image
              src="/images/landing/icons/social/colored/instagram.png"
              fill
              alt="instagram"
            />
          </div>
        </div>
      </div>

      <div className={c.videoSection}>
        <div className={clsx(c.section, c.sectionReverse)}>
          <div className={c.video}>
            <VideoPlayer
              video="/images/landing/new-homepage/testimonials-grid/judith-goldberg.mp4"
              image="/images/testimonials/judygoldberg-video-cover.png"
            />
          </div>
          <div className={c.textSection}>
            <div className={c.text}>
              I love the content, I think it&apos;s excellent. It&apos;s short
              and sweet just the way I like things, cause everybody&apos;s in a
              hurry. We really want one -- Right click on the video, right click
              on the link. they need that. We need that.
            </div>
            <div className={c.footer}>
              <b>— Judith Goldberg</b>
              <div className={c.descriptionWrapper}>
                <div className={c.description}>Pacific Regent Realty</div>
                <div className={c.location}>
                  <div className={c.icon}>
                    <Image
                      src="/images/testimonials/location-blue.svg"
                      fill
                      alt=""
                    />
                  </div>
                  <div className={c.locationText}>San Diego</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={c.section}>
          <div className={c.video}>
            <VideoPlayer
              video="/images/landing/new-homepage/testimonials-grid/aburey-hamid.mp4"
              image="/images/testimonials/aubreyhamid-video.png"
            />
          </div>
          <div className={c.textSection}>
            <div className={c.text}>
              I’m enjoying it, I like that the videos are short and I can put it
              out there and they can be effective. I’ve got great expectations,
              these videos workin’ for me!
            </div>
            <div className={c.footer}>
              <b>— Aubrey Hamid</b>
              <div className={c.descriptionWrapper}>
                <div className={c.description}>Real Estate 360 Inc</div>
                <div className={c.location}>
                  <div className={c.icon}>
                    <Image
                      src="/images/testimonials/location-blue.svg"
                      fill
                      alt=""
                    />
                  </div>
                  <div className={c.locationText}>Cupertino</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={clsx(c.section, c.sectionReverse)}>
          <div className={c.video}>
            <VideoPlayer
              video="/images/landing/new-homepage/testimonials-grid/ramesh-rao.mp4"
              image="/images/testimonials/rameshrao-video.png"
            />
          </div>

          <div className={c.textSection}>
            <div className={c.text}>
              Everybody knows videos get more eyeballs than static picture. What
              I like is having these videos, people can get the main gist of
              what I want to say in 30 seconds. You’re one of the first ones to
              post videos, this is why I didn’t even need a trial
            </div>
            <div className={c.footer}>
              <b>— Ramesh Rao</b>
              <div className={c.descriptionWrapper}>
                <div className={c.description}>
                  Coldwell Banker Residential Brokerage
                </div>
                <div className={c.location}>
                  <div className={c.icon}>
                    <Image
                      src="/images/testimonials/location-blue.svg"
                      fill
                      alt=""
                    />
                  </div>
                  <div className={c.locationText}>Orlando</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={c.testimonialGrid}>
        <TestimonialGrid title="&nbsp;" />
      </div>

      <div className={c.bookDemoWrapper}>
        <div className={c.banner}>
          <div className={c.texts}>
            <div>
              <span>Book a 15 minute Demo</span>
              <div className={c.under}>
                Learn how you could use Roomvu to build your social media
              </div>
            </div>
          </div>

          <div
            className={c.bookButton}
            onClick={() => {
              sendBookDemoEvent('testimonial-book-demo-section');
              dispatch(openNewPopup('book-demo-popup'));
            }}
          >
            <div className={c.circleButton}>
              <div className={c.icon}>
                <Image
                  objectFit="cover"
                  className={c.rounded}
                  src={`/images/testimonials/white-calendar-icon.svg`}
                  fill
                  alt=""
                />
              </div>
            </div>

            <div className={c.labels}>
              <div className={c.l1}>See Available Slots</div>
              <div className={c.l2}>
                <a href="#">Get VIP Help!</a>
              </div>
            </div>
          </div>
        </div>
        <div
          className={c.startSharing}
          onClick={() => {
            window.location.href = 'https://www.roomvu.com/register';
          }}
        >
          <div className={c.centered}>
            <div className={c.circleButton}>
              <div className={c.icon}>
                <Image
                  objectFit="cover"
                  className={c.rounded}
                  src={`/images/testimonials/share-button.svg`}
                  fill
                  alt=""
                />
              </div>
            </div>
            <div className={c.l1}>Start sharing real state videos</div>
            <button className={c.whiteButton}>Get Started Free</button>
          </div>
        </div>
      </div>

      <div className={c.testimonialGrid} style={{ background: 'transparent' }}>
        <CompanyLogo />
      </div>

      <Footer />
      <PopupManager />
    </>
  );
}
